export const getWindow = (): Window => {
  if (typeof window === 'undefined') {
    throw new Error('window is not defined');
  }
  return window;
};
